// Colors use the theme's CSS variables so this adapts to light/dark, unlike
// the static public/favicon.svg (browser tabs can't apply page theming).
//
// `variant="chrome"` (AppBar.tsx's only real caller, UI redesign phase 3) —
// the droplet's own cutout has to match whatever surface it's actually
// sitting on, and the app bar is the app's own dark identity band now
// (`--color-chrome`), not the ordinary content-area `--color-surface` every
// other caller (Landing.tsx, App.tsx's fatal-error screen) still sits on.
export function Logo({
  size = 32,
  variant = "surface",
}: {
  size?: number;
  variant?: "surface" | "chrome";
}) {
  const ring = variant === "chrome" ? "var(--color-chrome-accent)" : "var(--color-primary)";
  const cutout = variant === "chrome" ? "var(--color-chrome)" : "var(--color-surface)";
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true" className="app-logo">
      <circle cx="16" cy="16" r="15" fill={ring} />
      <path d="M16 6c4 5 7 9 7 13a7 7 0 0 1-14 0c0-4 3-8 7-13z" fill={cutout} />
      <g stroke={ring} strokeWidth="1.3" strokeLinecap="round">
        <line x1="13" y1="20" x2="18" y2="17" />
        <line x1="13" y1="20" x2="18" y2="23" />
      </g>
      <g fill={ring}>
        <circle cx="13" cy="20" r="1.4" />
        <circle cx="18" cy="17" r="1.4" />
        <circle cx="18" cy="23" r="1.4" />
      </g>
    </svg>
  );
}
